import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { api, errMsg } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const done = useRef(false);
  const [state, setState] = useState({ status: "working", message: "Verifying your email…" });

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    if (!token) return setState({ status: "error", message: "Missing verification token" });
    api
      .post("/auth/verify-email", { token })
      .then(({ data }) => setState({ status: "ok", message: data.message }))
      .catch((err) => setState({ status: "error", message: errMsg(err) }));
  }, [params]);

  return (
    <div className="min-h-screen grain flex items-center justify-center px-4">
      <div className="relative z-10 card-flat p-10 max-w-md w-full text-center reveal" data-testid="verify-email-panel">
        <div className="flex justify-center"><Logo size="md" testId="verify-email-logo" /></div>
        {state.status === "ok" ? (
          <CheckCircle2 className="w-10 h-10 text-emerald-600 mx-auto" />
        ) : state.status === "error" ? (
          <XCircle className="w-10 h-10 text-rose-600 mx-auto" />
        ) : null}
        <h1 className="mt-5 text-2xl font-extrabold">{state.status === "ok" ? "Email verified" : state.status === "error" ? "Could not verify" : "Verifying…"}</h1>
        <p className="mt-2 text-sm text-slate-500">{state.message}</p>
        <Link to="/login" data-testid="verify-email-login" className="mt-7 inline-block px-6 py-3 rounded-full bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800 transition-colors">
          Go to sign in
        </Link>
      </div>
    </div>
  );
}
